























































import { Component, Vue, Prop, Provide, Emit, Model } from 'vue-property-decorator';

@Component
export default class Popover extends Vue {
    @Prop({ default: 'bottom'})
    placement!: string;
    @Prop({ default: 'hover'})
    trigger!: string;
    @Prop({ default: false })
    loading!: boolean;
    @Prop({ default: false })
    border!: boolean;
    @Prop({ default: 'normal' })
    size!: string;
    @Prop()
    options!: any[];
    @Prop({ default: false })
    multiple!: boolean;

    @Model('change', { type: String | Number | Array })
    selectedModel!: string | number | string[];

    @Provide()
    visibleModel: boolean = false;

    get dropdownClass() {
        return [
            this.border ? 'border' : '',
            `size-${this.size}`,
        ]
    }

    get text() {
        if (this.selectedModel) {
            const item = _.find(this.options, { value: this.selectedModel });
            return item && item.label ? item.label : this.selectedModel;
        }
        return '';
    }

    get isSelect() {
        return value => {
            if (this.multiple) {
                return (this.selectedModel as Array).indexOf(value) > -1;
            }
            return value === this.selectedModel;
        }
    }

    @Emit('change')
    handleSelect(item) {
        const { value } = item;
        if (this.multiple) {
            const modelC = _.clone(this.selectedModel);
            const index = modelC.indexOf(value);
            if (index > -1) {
                modelC.splice(index, 1);
            } else {
                modelC.push(value);
            }
            return modelC;
        }
        return value;
    }
}
